import { Link } from "react-router-dom";
const CardComponent = ({ img, ref, title, desc,subheading }) => (
  <div className="flex flex-col w-[90%] lg:w-[26%] p-3 lg:p-0 lg:h-96 rounded-xl shadow-2xl border">
    <div className="flex justify-center items-center w-full h-[80%]">
      <img src={img} alt="logo" className="w-48"></img>
    </div>
    <p className="text-center font-bold mb-2 text-sm lg:text-base p-4">{subheading}</p>
    <Link to={ref} className="flex flex-col card-styling h-[20%] gap-2 p-2 ">
      <span className="text-xs lg:text-sm lg:px-4">{title}</span>
      <span className="text-xs lg:text-sm lg:px-4">{desc}</span>
    </Link>
  </div>
);

export default CardComponent;
